/* eslint-disable indent */
import i18n from 'i18n';
import { ProviderResourcesProps } from 'modules/environments/interfaces';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

export interface GenericFormItemWithLoadingKey extends GenericFormItem {
  isLoadingKey?: string;
}

const getFieldOptionsByProviderResources = (
  providerResources: ProviderResourcesProps,
  mapFields: Record<string, string>,
  field: GenericFormItemWithLoadingKey
) =>
  providerResources[mapFields[field?.stateKey]]?.results?.map(item => ({
    ...item,
    label:
      field?.stateKey === 'provider_data.image_id'
        ? `${item?.id} | ${item?.name}`
        : item?.name,
    value:
      field?.stateKey === 'provider_data.key_pair'
        ? item?.name
        : item?.id || item?.name,
    disabled: item?.state !== 'available',
  }));

export const createFieldOptions = (
  field: GenericFormItemWithLoadingKey,
  mapFields,
  providerResources: ProviderResourcesProps
) => {
  const optionName = i18n.t(field?.label).toLowerCase();
  const options = getFieldOptionsByProviderResources(
    providerResources,
    mapFields,
    field
  )?.filter(item => !item?.subnet_configuration_error);

  const isLoading =
    providerResources?.[mapFields[field?.stateKey]]?.[
      field?.isLoadingKey || ''
    ];
  return {
    ...field,
    options: options?.length
      ? options
      : [
          {
            label: i18n.t('ENVIRONMENTS_PAGE.NOT_HAVE_OPTION_KEY', {
              optionName,
            }),
            value: 'null',
          },
        ],
    label: isLoading
      ? i18n.t('ENVIRONMENTS_PAGE.LOADING_OPTION_KEY', {
          optionName,
        })
      : field?.label,
    disabled: isLoading,
  };
};
